export default __webpack_public_path__ + "static/media/greeting27.6ddb690c.png";